module.exports = __webpack_public_path__ + "img/gh.d0289dc0.png";